<template>
  <WithPagination
    v-slot="{ currentPageData }"
    :is-loading="isLoading"
    :data="formattedData"
    :is-raised="isRaised"
  >
    <slot
      :data="currentPageData"
      :filter-change="filterChanged"
      :sort-change="sortChanged"
    />
  </WithPagination>
</template>
<script>
import WithPagination from './WithPagination';

export default {
  name: 'WithPaginationAndFilters',
  components: {
    WithPagination,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isRaised: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      formattedData: this.data,
      filters: {},
      sort: {
        prop: '',
        order: '',
      },
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.formattedData = this.data;
        this.filterChanged(this.filters);
      },
    },
  },
  methods: {
    sortChanged({ prop, order }) {
      this.sort = { prop, order };
      this.formattedData.sort((a, b) => {
        const toNumberOrZero = x => (isNaN(x) ? 0 : Number(x));

        if (order === 'descending') {
          return toNumberOrZero(b[prop]) - toNumberOrZero(a[prop]);
        }
        return toNumberOrZero(a[prop]) - toNumberOrZero(b[prop]);
      });
    },
    filterChanged(filters) {
      this.filters = filters;
      const keys = Object.keys(filters);
      // Cloning the data so when we sort it, the original data won't be changed
      this.formattedData = [...this.data];
      keys.forEach(column => {
        if (filters[column].length === 0) return;
        this.formattedData = this.formattedData.filter(item =>
          filters[column].includes(item[column]),
        );
      });
      this.sortChanged(this.sort);
    },
  },
};
</script>
